function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9 14v7H2v-2h3.57C4 17.3 3 15 3 12.5A9.5 9.5 0 0112.5 3a9.5 9.5 0 019.5 9.5 9.5 9.5 0 01-9.5 9.5H12v-2h.5a7.5 7.5 0 007.5-7.5A7.5 7.5 0 0012.5 5 7.5 7.5 0 005 12.5c0 1.97.76 3.76 2 5.1V14h2z"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgComponent;